// // import node module libraries
import { Link } from 'react-router-dom';
import {
    Container,
    Button,
    Row,
    Col,
    Navbar,
    Card,
    Form,
    Nav,
    Image
} from 'react-bootstrap';
import { useState, useRef } from 'react';
import Url from "../Url";

const EditProfile = () => {
    const url1 = Url();
    const url = url1["url"];
    const s3URL = url1["S3"];   

    const hiddenFileInput = useRef(null);
    const [avatar, setAvatar] = useState(s3URL + "Account.svg");

    // Form State
    const [formData, setFormData] = useState({
        fullName: '',
        mobileNo: '',
        email: '',
        organizationName: '',
        organizationDescription: '',
        address: '',
        website: ''
    });

    // Validation State
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        if (e.target.type === 'file') {
            setAvatar(URL.createObjectURL(e.target.files[0]));
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };

    const validateForm = () => {
        let errors = {};

        if (!formData.fullName.trim()) errors.fullName = "Full Name is required";
        if (!formData.mobileNo.match(/^[0-9]{10}$/)) errors.mobileNo = "Enter a valid 10-digit Mobile Number";
        if (!formData.email.match(/^\S+@\S+\.\S+$/)) errors.email = "Enter a valid Email";
        if (!formData.organizationName.trim()) errors.organizationName = "Organization Name is required";
        if (!formData.organizationDescription.trim()) errors.organizationDescription = "Organization Description is required";
        if (!formData.address.trim()) errors.address = "Address is required";
        if (!formData.website.match(/^(https?:\/\/)?([\w\d\-]+\.)+[\w\d]{2,}(\/.*)?$/)) errors.website = "Enter a valid Website URL";

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            alert("Profile Updated Successfully!");
        }
    };

    return (
        <section className="pt-5 pb-6">
            <Container>
                <Row>
                    <Col lg={3} sm={12}>
                        <Card className="mb-4">
                            <Navbar expand="lg" className="sidebar-menu">
                                <Link className="d-lg-none" to="#">Menu</Link>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" className="p-0 focus-none border-0">
                                    <span className="navbar-toggler-icon"></span>
                                </Navbar.Toggle>
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="nav flex-column w-100" as="ul" activeKey="0">
                                        <Nav.Item as="li">
                                            <Link className="nav-link" to="#">Dashboard</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li">
                                            <Link className="nav-link active" to="#">Profile</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li">
                                            <Link className="nav-link" to="#">Change password</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li">
                                            <Link className="nav-link" to="#">Post Internship</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li">
                                            <Link className="nav-link" to="#">Sign Out</Link>
                                        </Nav.Item>
                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                        </Card>
                    </Col>
                    <Col lg={9}>
                        <div className="mt-6 mt-lg-0 mb-4">
                            <div className="border-bottom mb-4 pb-4">
                                <h2 className="mb-0">Profile</h2>
                            </div>
                            <Form className="row" noValidate onSubmit={handleSubmit}>
                                <Col xs={12} className="mb-3">
                                    <h3>Personal Details</h3>
                                    <p>Edit your organization details, address and website etc...</p>
                                </Col>
                                <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Full Name</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Enter full Name" 
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.fullName}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Mobile No.</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Enter Mobile No." 
                                        name="mobileNo"
                                        value={formData.mobileNo}
                                        onChange={handleChange}
                                        isInvalid={!!errors.mobileNo}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.mobileNo}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Email Account</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        placeholder="Enter Email Account"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                </Form.Group>
                                <Col xs={12} className="mb-3 mt-6">
                                    <h3>Organization Details</h3>
                                </Col>
                                <Col xs={12} className="mb-5">
                                    <div className="d-flex">
                                        <div className="d-flex align-items-center position-relative">
                                            <span>
                                                <Image className="image avatar avatar-md rounded-circle" src={avatar} alt="Image" />
                                                <div className="file-upload">
                                                    <Form.Control type="file" className="file-input" ref={hiddenFileInput} onChange={handleChange} />
                                                </div>
                                            </span>
                                            <div className="ms-3">
                                                <h4 className="mb-1">Organization logo</h4>
                                                <small>Max file size: 1Mb and max resolution: 500px x 500px. File type: jpeg, jpg, png, gif, bmp</small>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Organization Name</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="e.g. internshipgate"
                                        name="organizationName"
                                        value={formData.organizationName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.organizationName}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.organizationName}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Organization Description</Form.Label>
                                    <Form.Control 
                                        as="textarea" 
                                        rows={3} 
                                        placeholder="Write Description"
                                        name="organizationDescription"
                                        value={formData.organizationDescription}
                                        onChange={handleChange}
                                        isInvalid={!!errors.organizationDescription}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.organizationDescription}</Form.Control.Feedback>
                                </Form.Group>
                                <Col lg={6}>
                                    <Button variant="primary" type="submit">Update Profile</Button>
                                    <Button variant="outline-primary" className="ms-1" type="button">Cancel</Button>
                                </Col>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default EditProfile;
